<template>
  <div>
    <h6 class="magic-link">
      <!-- <span class="magic-link-user">Hello {{ tokenLink }} </span><br /> -->
      <span class="magic-link-message">Please wait! we are logging you in...</span>
    </h6>
  </div>
</template>

<script>
import service from '../services';
import {global} from '../global.js';
import { mapGetters, mapActions } from "vuex";

export default {
  data() {
    return {
      email: '',
      token: '',
      loading: false,
      credential_err: '',
      languageSelected:'en',
      domainLogo: null,
      clientdata: null,
      login_image: "",
      login_text: "",
      loginType: false,
      language: 'en',
      app_source: false,
      client_id: ''
    };
  },
  computed: {
    // tokenLink() {
    //   if(this.$route.params.tokenLink) {
    //     return this.$route.params.tokenLink;
    //   }
    //   return null;
    // },
    ...mapGetters({
      queryParamClientId: 'queryParamClientId',
      queryParamAppSource: 'queryParamAppSource'
    }),
    deviceDetector() {
        let userAgent = navigator.userAgent.toLowerCase();
        const check =(/(ipad|tablet|(android(?!.*mobile))|(windows(?!.*phone)(.*touch))|kindle|playbook|silk|(puffin(?!.*(IP|AP|WP))))/.test(userAgent) ? "tablet" : /(mobi|ipod|phone|blackberry|opera mini|fennec|minimo|symbian|psp|nintendo ds|archos|skyfire|puffin|blazer|bolt|gobrowser|iris|maemo|semc|teashark|uzard)/.test(userAgent) ? "phone" : "desktop");
                    
        return("desktop" != check ? !0 : !1);
    }
  }, 
  methods: {
    async loginUser() {
      let params = {
        email: '',
        token: '',
        url: ''
      }
      if(this.email&&this.token) {
        params.email = this.email;
        params.token = this.token;
        params.url = window.location.href.split('#')[0];
        params.client_id = this.client_id;
        await service.post('auth/magic-link/swapMagicLinkToken', params)
        .then(async (res) => {
          let queryParams = {
            app_source: this.app_source,
            client_id: this.client_id
          }
          queryParams = JSON.stringify(queryParams);
          localStorage.setItem('queryParams', queryParams);
          await this.getIntoApp(res);
          // console.log(res.data)
        }).catch((err) => {
          console.log(err);
          this.$notify.error({
            message: 'Something went wrong! Please contact Support team',
            title: 'Error'
          });
          this.$router.push({
            path: '/login'
          })
        });
      } else {
        this.$notify.error({
          message: 'Something went wrong! Please contact Support team',
          title: 'Error'
        });
        this.$router.push({
            path: '/login'
        })
      }
    },

    async getIntoApp(res) {
        localStorage.removeItem('vuex');
        if (res.data.status_code == 0) {
            this.$Progress.fail();
            this.loading = false;
            this.credential_err = res.data.status_message;
            // console.log(this.credential_err);
        } else {
            let data = res.data.result;
            // console.log('correct',  data);
            this.$store.dispatch('userSession', data);
            this.$store.dispatch('setLoginSuper', false);
            // console.log('***************** ');
            this.$cookies.set("csLogin", data.role.slug, "23h");
            this.$cookies.set("csLogin", data.role.slug, "23h",'/mobile');
            this.credential_err = "";
            this.$Progress.finish();
            $('.wrapper').css('margin-left', '60px');
            /* for support chat box.*/
            let self = this;
            let employeeObjs = data.user.employees.length ? data.user.employees : [];
            let clients = [];
            if(employeeObjs.length) {
              clients = employeeObjs.filter((emp) => {
                return emp.client_employee && emp.client_employee.clients && emp.client_employee.clients.id == this.client_id
              })
            }
            if(clients.length) {
              this.$store.dispatch('setEmployeeId', clients[0].client_employee.client_id);
            }
            var a = JSON.parse(localStorage.getItem('vuex'));
            console.log(a);
            var userRole = a && a.user && a.user.userData && a.user.userData.role?a.user.userData.role.slug:null;
            // console.log('correct 1');
            if(userRole){
                var tags =['csSupport'];
                var restoreId =null;
                var client = null;
                var phone ='';
                var user_id ='';
                var first_name="";
                var last_name="";
                var email=""
                if(a.user.userData.user && a.user.userData.user.freshchat){
                    restoreId = a.user.userData.user.freshchat.restore_id;
                }
                if(userRole!='employer-admin' && userRole!='employer' && userRole!='super-admin' && a.user.userData.user && a.user.userData.user.employees && a.user.userData.user.employees.length && a.user.userData.user.employees[0].client_employee && a.user.userData.user.employees[0].client_employee.clients){
                    client = a.user.userData.user.employees[0].client_employee.clients.subdomain;
                }
                if(a.user.userData.user){
                    user_id = a.user.userData.user.id;
                    first_name = a.user.userData.user.first_name;
                    last_name = a.user.userData.user.last_name;
                    email = a.user.userData.user.email;
                    if(a.user.userData.user.phones && a.user.userData.user.phones.length){
                        phone = a.user.userData.user.phones[0].phone_number;
                    }
                }
                if(userRole=='employee' || userRole=='power-user'){
                    if(a.user.userData.user && a.user.userData.user.employees){
                        for(var key in a.user.userData.user.employees){
                            if(a.user.userData.user.employees[key].client_employee && a.user.userData.user.employees[key].client_employee.clients && a.user.userData.user.employees[key].client_employee.clients["widget_tags"]){
                                var temp_tags = JSON.parse(a.user.userData.user.employees[key].client_employee.clients["widget_tags"]);
                                if(temp_tags && temp_tags.length){
                                    tags=tags.concat(temp_tags)
                                }
                            }
                        }
                    }
                }

                localStorage.setItem('tags', JSON.stringify(tags));
                // console.log(window.fcWidget);
                
                await window.fcWidget.init({
                    token:"5f5b4092-cff9-4586-9c85-5d4c79365f71",
                    host: "https://wchat.freshchat.com",
                    externalId: a.user.userData.user.id,
                    restoreId: restoreId? restoreId : null,
                    tags: tags,
                    config: {
                        headerProperty: {
                        backgroundImage: 'https://admin.callsteward.com/static/assets/images/login-bg.jpg',
                        //Hide the chat button on load
                        hideChatButton: false,
                        //Set Widget to be left to right.
                        // direction: 'ltr'
                        }
                    }
                });
                console.log("Check 0:")
                window.fcWidget.user.get(function(resp) {
                    console.log("Check 1", resp);
                    var status = resp && resp.status,
                    data = resp && resp.data;
                    console.log('Get User Success', resp)
                    if (status !== 200) {
                        console.log('Get User not 200', resp)
                        window.fcWidget.user.setProperties({
                            firstName: a.user.userData.user.first_name,              // user's first name
                            lastName: a.user.userData.user.last_name,                // user's last name
                            email: a.user.userData.user.email,    // user's email address
                            phone: String(phone),            // phone number without country code
                            client: String(client),   // user's meta property 3
                            role: String(userRole),
                            plan: "Estate",                 // user's meta property 1
                            status: "Active",               // user's meta property 2
                            "Restore Id": restoreId?restoreId:null
                        });
                        console.log("FcWidget created Start");
                        window.fcWidget.on('user:created', ((resuser) => {
                            console.log('on User created', resuser)
                            var status = resuser && resuser.status,
                                data = resuser && resuser.data;
                            if (status == 200 || status == 201) {
                                if (data.restoreId) {
                                    console.log('on restored id found', resuser)
                                    let formData={
                                        userId: a.user.userData.user.id,
                                        aliasId: data.alias,
                                        restoreId: data.restoreId
                                    }
                                    // console.log('setProperties', formData);
                                    service.post('employee/saveFreshchatId', formData, {
                                        'Authorization': self.userToken,
                                        'cs3-context-role': self.userRole,
                                        'cs3-context-clientId': self.userClientID,
                                    })
                                    .then((res) => {
                                        console.log('updated fresh chat Ids.')
                                    }).catch((err) => {
                                        console.log(err);
                                    })
                                }
                            }
                        }));
                    }else {
                        console.log(data);
                    }
                });
            }
            /* END CHAT SUPPORT */

            if (data.role.slug == "client-admin" || data.role.slug == "employee" || data.role.slug == "power-user" || data.role.slug == "auditor") {
                if(data.user && data.user.employees && data.user.employees.length && data.user.employees[0].client_employee && data.user.employees[0].client_employee.clients){
                    // console.log('***************** 1');
                    this.$cookies.set("time_zone", data.user.employees[0].client_employee.clients.timezone, "23h");
                    this.$cookies.set("date_format", data.user.employees[0].date_format, "23h");
                    this.$cookies.set("time_format", data.user.employees[0].time_format, "23h");
                    this.$cookies.set("powerSteward", data.user.employees[0].client_employee.clients.power_steward, "23h");
                    var notifyType = (data.user.employees[0].email_notification == 1) ? 'email' : 'sms';

                    this.$store.dispatch('setNotificationType', notifyType);
                    this.$store.dispatch('setClientdata', data.user.employees[0].client_employee.clients);
                }
                let query_params = {};
                if (this.app_source) {
                  query_params.app_source = this.app_source;
                }
                if (this.client_id && this.client_id != '') {
                  query_params.client_id = this.client_id;
                }
                // console.log('***************** 2');
                if (data.role.slug == "client-admin" || data.role.slug == "power-user") {
                    this.$store.dispatch('setLastOpenJob', 0);
                    //for heard refresh.
                    //location.reload(true);
                    if(data.role.slug == "power-user"){
                        this.$router.push({
                            path: "/switchClient",
                            query: query_params
                        });
                    }
                    else{
                        this.$router.push({
                            path: "/jobList"
                        });
                    }
                } else {
                    if(document.getElementsByTagName('body')[0].clientWidth < 700)
                    {
                        this.$cookies.set("csLogin", data.role.slug, "23h",'/mobile');
                        this.$cookies.set("date_format", data.user.employees[0].date_format, "23h", '/mobile');
                        this.$cookies.set("time_format", data.user.employees[0].time_format, "23h", '/mobile');
                        if(!this.app_source){
                          window.location.href = window.location.href.split('#')[0]+"mobile/";
                        }
                    } else{
                        //for heard refresh.
                        //location.reload(true);


                        this.$router.push({
                            path: "/switchClient",
                            query: query_params
                        });


                        // this.$router.push({
                        //     path: "/schedule/"+btoa(this.employeeId),
                        // });
                    }
                }

            } else if(data.role.slug == "employer-admin" || data.role.slug == "employer"){

                //console.log("Hi I am Employer Admin.");
                this.$router.push({
                    path: "/employerJobList"
                });

            } else if(data.role.slug == "super-admin") {
                //location.reload(true);
                this.$router.push({
                    path: "/clientList"       
                });
            }                                
        }
        this.loading=false;
    },

    async domainIdentify() {
      this.loading=true;
      await service.get('auth/domain', {
          'url': document.location.href.split('#')[0] + "#/login",
      })
      .then((res) => {
          // console.log(res.data);
          this.domainLogo = (res.data.result)?res.data.result.logo:null;
          this.clientdata=(res.data.result)?res.data.result:null;
          this.login_image=this.clientdata?this.clientdata.login_image:"";
          this.login_text=this.clientdata?this.clientdata.login_page_message:"";
          this.loginType=(this.clientdata.view_switch==1)?true:false;
          //console.log("Domain", this.clientdata);
          this.loading=false;

      }).catch((err) => {
          this.loading=false;
          this.$Progress.fail();
      });
    }
  },
  async created() {
    localStorage.setItem('queryParams', null);
    this.app_source = this.$route.query.app_source ? this.$route.query.app_source : false;
    this.client_id = this.$route.query.client_id ? this.$route.query.client_id : '';
    // console.log(this.app_source,this.client_id);
    this.$store.dispatch('setQueryParamClientId', this.client_id);
    this.$store.dispatch('setQueryParamAppSource', this.app_source);
    // console.log(this.queryParamClientId,this.queryParamAppSource);
    const isMobile = this.deviceDetector;
    this.language = this.$route.query.lang ? this.$route.query.lang : 'en';
    // console.log(this.language);
    this.languageSelected = this.language;
    localStorage.setItem('lang', this.languageSelected);
    this.$store.dispatch('saveBrowserSettingsLanguage', this.language);
    if(isMobile&&!this.app_source) {
      // console.log("Mobile");
      let firstPath = window.location.href.split('#')[0];
      let secondPath = window.location.href.split('#')[1];
      // console.log(firstPath + 'mobile/#' + secondPath);
      window.location.href = firstPath + 'mobile/#' + secondPath;
    } else {
      console.log("Web");
      this.email = this.$route.query.email ? this.$route.query.email : null;
      this.token = this.$route.query.token ? this.$route.query.token : null;
      await this.domainIdentify();
      await this.loginUser();
    }
  },
  mounted() {},
  destroyed() {
    if(this.language == 'sp') {
      this.language = 'es';
    }
    this.languageSelected = this.language;
    this.$store.dispatch('saveBrowserSettingsLanguage', this.language);
    localStorage.setItem('lang', this.languageSelected);
    // location.reload();
  }

}
</script>

<style scoped>
.magic-link {
  margin: 15%;
  font-size: 16px;
  line-height: 2;
  font-weight: 400;
}
.magic-link .magic-link-user {
  color: #ff8800;
  font-weight: 400;
}
.magic-link .magic-link-message {
  color: #0b8300;
  font-weight: bold;
}
</style>



// WEBPACK FOOTER //
// src/components/magicLink.vue